import { render, staticRenderFns } from "./ECommerceMenu.vue?vue&type=template&id=6dd5b4de&"
import script from "./ECommerceMenu.vue?vue&type=script&lang=js&"
export * from "./ECommerceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports